import {
  Role,
  ActionType,
  ActionValue,
  Permissions,
} from '@versita/shared/models';
import {
  pick,
  pipe,
  uniq,
  flatten,
  values,
  intersection,
  complement,
  isEmpty,
  ifElse,
  map,
  is,
} from 'ramda';

export const checkPermissions = (
  roles: Role[],
  ...actionsToCheck: (ActionValue | ActionType)[]
): boolean => {
  const actions = normaliseActionArgs(actionsToCheck);
  if (!actions.length) return true;
  const permissions = roles.length
    ? getPermissions(pick(roles as [Role, ...Role[]], Permissions))
    : [];

  return permissionsIncludeAnyAction(actions, permissions);
};

const normaliseActionArgs = pipe(
  map(ifElse(is(String), Array.of, values)),
  flatten,
);
const getPermissions = pipe(values, flatten, uniq);
const isNotEmpty = complement(isEmpty);
const permissionsIncludeAnyAction = pipe<
  [string[], string[]],
  string[],
  boolean
>(intersection, isNotEmpty);
